var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0067E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.9999C14.5 18.1325 14.4473 18.2597 14.3535 18.3534C14.2598 18.4472 14.1326 18.4999 14 18.4999H10C9.86739 18.4999 9.74022 18.4472 9.64645 18.3534C9.55268 18.2597 9.5 18.1325 9.5 17.9999C9.5 17.8673 9.55268 17.7401 9.64645 17.6463C9.74022 17.5526 9.86739 17.4999 10 17.4999H14C14.1326 17.4999 14.2598 17.5526 14.3535 17.6463C14.4473 17.7401 14.5 17.8673 14.5 17.9999ZM18.5 7.99988V14.9999C18.4995 15.3976 18.3414 15.7788 18.0602 16.06C17.779 16.3412 17.3977 16.4994 17 16.4999H7C6.60232 16.4994 6.22105 16.3412 5.93984 16.06C5.65864 15.7788 5.50045 15.3976 5.5 14.9999V7.99988C5.50045 7.60219 5.65864 7.22093 5.93984 6.93972C6.22105 6.65851 6.60232 6.50033 7 6.49988H17C17.3977 6.50033 17.779 6.65851 18.0602 6.93972C18.3414 7.22093 18.4995 7.60219 18.5 7.99988ZM14.5 11.4999C14.4999 11.4176 14.4795 11.3366 14.4407 11.264C14.4018 11.1915 14.3457 11.1296 14.2773 11.0838L11.2773 9.08385C11.2021 9.03356 11.1145 9.00467 11.0241 9.00026C10.9337 8.99585 10.8438 9.01608 10.7639 9.0588C10.6841 9.10152 10.6174 9.16511 10.5709 9.2428C10.5244 9.32048 10.4999 9.40933 10.5 9.49986V13.4999C10.5 13.5904 10.5246 13.6792 10.5711 13.7568C10.6176 13.8344 10.6843 13.898 10.7641 13.9407C10.8439 13.9834 10.9337 14.0037 11.0241 13.9993C11.1145 13.9949 11.202 13.9661 11.2773 13.9159L14.2773 11.9159C14.3457 11.8701 14.4018 11.8083 14.4407 11.7357C14.4795 11.6631 14.4999 11.5822 14.5 11.4999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.d62fd6de.svg";
export { ForwardRef as ReactComponent };